import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = { class: "p-3" }
const _hoisted_5 = { class: "d-flex justify-content-end" }

import { dbEnums } from "@/types/enums/dbEnums";
import { DraftImmigrantDto } from "@api/draft-immigrant-dto";
import { PropType, computed } from "vue";
import { PersonFieldCategoryMap } from "..";
import Field from "../../Field.vue";
import FormFields from "../../FormFields.vue";
import FormSection from "../../FormSection.vue";
import FormSectionHeader from "../../FormSectionHeader.vue";
import ClassificationInformationsSelect from "@/components/ClassificationInformationsSelect.vue";
import { EducationInfoDto } from "@api/education-info-dto";
import { useValidateProps } from "@/composables/fields";
import OccupationalCompetenceSelect from "@/components/OccupationalCompetenceSelect.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImmigrantFormEducationFields',
  props: {
	fieldsMap: {
		type: Object as PropType<PersonFieldCategoryMap>,
		required: true,
	},
	modelValue: {
		type: Object as PropType<DraftImmigrantDto>,
		required: true,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const fields = dbEnums.PersonFields;

const formDataComputed = computed({
	get() {
		return props.modelValue;
	},
	set(v) {
		emit("update:modelValue", v);
	},
});

const addEducationInfo = () => {
	if (!formDataComputed.value.educationInfos) {
		formDataComputed.value.educationInfos = [];
	}
	formDataComputed.value.educationInfos.push({
		degree: "",
		institution: "",
		graduationYear: null,
		municipalityFreeText: "",
		municipalityId: null,
		municipality: null,
		id: 0,
		draftImmigrantId: 0,
	} as EducationInfoDto);
};

const removeEducationInfo = (index: number) => {
	if (formDataComputed.value.educationInfos) {
		formDataComputed.value.educationInfos?.splice(index, 1);
	}
};

const validateProps = useValidateProps();

return (_ctx: any,_cache: any) => {
  const _component_HakoTextArea = _resolveComponent("HakoTextArea")!
  const _component_HakoInput = _resolveComponent("HakoInput")!
  const _component_HakoButton = _resolveComponent("HakoButton")!

  return (_openBlock(), _createBlock(FormSection, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FormSectionHeader, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("immigrantForm.sectionHeaders.educationInfo")), 1)
            ]),
            _: 1
          })
        ]),
        (__props.fieldsMap.ImmigrantEducation)
          ? (_openBlock(), _createBlock(FormFields, {
              key: 0,
              fields: __props.fieldsMap.ImmigrantEducation.fields
            }, {
              [_unref(fields).ImmigrantEducationAndQualificationLevels]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.educationAndQualificationLevels"
                }, {
                  default: _withCtx(({ isInvalid, propertyPaths }) => [
                    _createVNode(ClassificationInformationsSelect, {
                      valueMulti: formDataComputed.value.educationAndQualificationLevels,
                      "onUpdate:valueMulti": _cache[0] || (_cache[0] = ($event: any) => ((formDataComputed.value.educationAndQualificationLevels) = $event)),
                      infoTable: "EducationAndQualificationLevels",
                      translationsTable: "EducationAndQualificationLevelTranslations",
                      translationProperty: "name",
                      ajax: false,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      style: {"max-width":"500px"}
                    }, null, 8, ["valueMulti", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).ImmigrantEducationDescription]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.educationDescription"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.educationDescription,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formDataComputed.value.educationDescription) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).ImmigrantPermitAndCardTrainings]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.permitAndCardTrainings"
                }, {
                  default: _withCtx(({ isInvalid, propertyPaths }) => [
                    _createVNode(ClassificationInformationsSelect, {
                      valueMulti: formDataComputed.value.permitAndCardTrainings,
                      "onUpdate:valueMulti": _cache[2] || (_cache[2] = ($event: any) => ((formDataComputed.value.permitAndCardTrainings) = $event)),
                      infoTable: "PermitAndCardTrainings",
                      translationsTable: "PermitAndCardTrainingTranslations",
                      translationProperty: "name",
                      ajax: false,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      style: {"max-width":"500px"}
                    }, null, 8, ["valueMulti", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).ImmigrantPermitAndCardTrainingsOccupationalCompetence]: _withCtx(({ field }) => [
                (formDataComputed.value.permitAndCardTrainings.length > 0)
                  ? (_openBlock(), _createBlock(Field, {
                      key: 0,
                      field: field,
                      propertyPath: "draftImmigrantData.permitAndCardTrainingsOccupationalCompetence"
                    }, {
                      default: _withCtx(({ isInvalid }) => [
                        _createVNode(OccupationalCompetenceSelect, {
                          valueMulti: 
								formDataComputed.value.permitAndCardTrainingOccupationalCompetences
							,
                          "onUpdate:valueMulti": _cache[3] || (_cache[3] = ($event: any) => ((
								formDataComputed.value.permitAndCardTrainingOccupationalCompetences
							) = $event)),
                          type: "PermitAndCard",
                          options: formDataComputed.value.permitAndCardTrainings,
                          isInvalid: isInvalid
                        }, null, 8, ["valueMulti", "options", "isInvalid"])
                      ]),
                      _: 2
                    }, 1032, ["field"]))
                  : _createCommentVNode("", true)
              ]),
              [_unref(fields).ImmigrantEducationInfos]: _withCtx(({ field }) => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(Field, { field: field }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formDataComputed.value.educationInfos, (educationInfo, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "card mb-2",
                          key: i
                        }, [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(Field, {
                              field: field,
                              label: _ctx.$t('immigrantForm.educationInfoDegree'),
                              propertyPath: `draftImmigrantData.educationInfos[${i}].degree`
                            }, {
                              default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                                _createVNode(_component_HakoInput, {
                                  modelValue: educationInfo.degree,
                                  "onUpdate:modelValue": ($event: any) => ((educationInfo.degree) = $event),
                                  id: elementId,
                                  isInvalid: isInvalid,
                                  onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                                  style: {"max-width":"500px"}
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "isInvalid", "onBlur"])
                              ]),
                              _: 2
                            }, 1032, ["field", "label", "propertyPath"]),
                            _createVNode(Field, {
                              field: field,
                              label: _ctx.$t('immigrantForm.educationInfoInstitution'),
                              propertyPath: `draftImmigrantData.educationInfos[${i}].institution`
                            }, {
                              default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                                _createVNode(_component_HakoInput, {
                                  id: elementId,
                                  modelValue: educationInfo.institution,
                                  "onUpdate:modelValue": ($event: any) => ((educationInfo.institution) = $event),
                                  isInvalid: isInvalid,
                                  onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                                  style: {"max-width":"500px"}
                                }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "isInvalid", "onBlur"])
                              ]),
                              _: 2
                            }, 1032, ["field", "label", "propertyPath"]),
                            _createVNode(Field, {
                              field: field,
                              label: _ctx.$t('immigrantForm.educationInfoGraduationYear'),
                              propertyPath: `draftImmigrantData.educationInfos[${i}].graduationYear`
                            }, {
                              default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                                _createVNode(_component_HakoInput, {
                                  id: elementId,
                                  type: "number",
                                  modelValue: educationInfo.graduationYear,
                                  "onUpdate:modelValue": ($event: any) => ((educationInfo.graduationYear) = $event),
                                  isInvalid: isInvalid,
                                  onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                                  style: {"max-width":"250px"}
                                }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "isInvalid", "onBlur"])
                              ]),
                              _: 2
                            }, 1032, ["field", "label", "propertyPath"]),
                            _createVNode(Field, {
                              field: field,
                              label: _ctx.$t('immigrantForm.educationInfoMunicipalityFreeText'),
                              propertyPath: `draftImmigrantData.educationInfos[${i}].municipalityFreeText`
                            }, {
                              default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                                _createVNode(_component_HakoInput, {
                                  id: elementId,
                                  modelValue: educationInfo.municipalityFreeText,
                                  "onUpdate:modelValue": ($event: any) => ((educationInfo.municipalityFreeText) = $event),
                                  isInvalid: isInvalid,
                                  onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                                  style: {"max-width":"250px"}
                                }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "isInvalid", "onBlur"])
                              ]),
                              _: 2
                            }, 1032, ["field", "label", "propertyPath"]),
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_HakoButton, {
                                theme: "danger",
                                onClick: () => removeEducationInfo(i)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("immigrantForm.removeEducationInfo")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ])
                        ]))
                      }), 128)),
                      _createVNode(_component_HakoButton, { onClick: addEducationInfo }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("immigrantForm.addEducationInfo")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["field"])
                ])
              ]),
              _: 2
            }, 1032, ["fields"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})